var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-image',{ref:"self",attrs:{"config":_vm.item},on:{"tap":function($event){return _vm.$emit('click', $event)},"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }